<template>
  <div class="wrapper">
    <div class="icons">
      <div class="icons-wrapper">
        <div class="icons-wrapper-main">
          <a id="fbook" v-bind:href="facebook" target="_blank">
            <font-awesome-icon :icon="['fab', 'facebook-f']" />
          </a>
          <a id="tiktok" v-bind:href="tiktok" target="_blank">
            <font-awesome-icon :icon="['fab', 'tiktok']" />
          </a>
          <a id="instagram" v-bind:href="instagram" target="_blank">
            <font-awesome-icon :icon="['fab', 'instagram']" />
          </a>
          <a id="youtube" v-bind:href="youtube" target="_blank">
            <font-awesome-icon :icon="['fab', 'youtube']" />
          </a>
        </div>
      </div>
    </div>
    <hr />
    <div class="contact-information">
      <div class="contact-email">
        <a id="email" v-bind:href="emaillink" target="_blank">info@angelcontreras.art</a>
      </div>
      <div class="gallery-website">
        <a id="gallery" v-bind:href="gallerylink" target="_blank">galeriaelattico.com</a>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "footer1",
  data: function() {
    return {
      emaillink:
        "https://mail.google.com/mail/?view=cm&fs=1&to=info@angelcontreras.art",
      gallerylink: "https://www.galeriaelattico.com",
      facebook: "https://www.facebook.com/artAngelcontreras",
      tiktok: "https://www.tiktok.com/@elkingconejoart?",
      instagram: "https://www.instagram.com/a.contreras_art/",
      youtube: "https://www.youtube.com/channel/UCMrGxjHolamx9Lt_r8b92yg"
    };
  }
};
</script>

<style scoped>
/* * {
  border: 1px solid black;
} */

hr {
  display: block;
  height: 1px;
  border: 0;
  border-top: 1px solid rgb(109, 109, 109);
  margin: 0;
  padding: 0;
}

.wrapper {
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
}
.contact-information {
  font-size: small;
  display: flex;
  justify-content: center;
  text-align: center;
  padding-top: 10px;
  padding-bottom: 15px;
  color: rgb(237, 237, 237);
   font-size:3.5vw;
}
.contact-information > div {
  width: 50%;
}
a {
  color: rgb(238, 238, 238);
  text-decoration: none;
}
a:active {
  color: red;
}
#fbook:hover {
  color: blue;
}
#tiktok:hover {
  color: aqua;
}
#instagram:hover {
  color: rgb(232, 76, 76);
}
#youtube:hover {
  color: red;
}

#email:hover, #gallery:hover {
  color: aquamarine;
}
.icons {
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 10px;
}

.icons-wrapper {
  font-size: min(20vw, 45px);
  color: rgb(238, 238, 238);
  width: 60%;
}
.icons-wrapper-main {
  width: 100%;
  display: flex;
  justify-content: space-between;
}



#fbook {
  animation: shake 0.80s;
  animation-delay: 2s; 
}
#tiktok {
  animation: shake 0.80s;
  animation-delay: 2.2s; 
}
#instagram {
  animation: shake 0.80s;
  animation-delay: 2.4s; 
}
#youtube {
  animation: shake 0.80s;
  animation-delay: 2.6s; 
}


</style>
